// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  Interceptor: (t, data?, options?) => t('enum.rtc-bot-type.interceptor.name', data, options),
  TeacherRecruitment: (t, data?, options?) => t('enum.rtc-bot-type.teacher-recruitment.name', data, options),
  TestCall: (t, data?, options?) => t('enum.rtc-bot-type.test-call.name', data, options),
  /* eslint-enable max-len */
};
